export const delayKindEnum = Object.freeze({
    CLIENT_DELAY:       1,
    CLIENT_ADVANCE:     2,
    CLIENT_RESTORE:     3,
    COMPANY_DELAY:      4,
    COMPANY_ADVANCE:    5,
    GOD_CLIMA:          6,
    GOD_EVENT:          7
});